import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { touch, focus } from 'redux-form';

import * as common from 'libs/commonFunc';
import * as commonVar from 'libs/commonVar';

import * as userActions from 'modules/user';
import * as loginActions from 'modules/login';
import * as currentStatusActions from 'modules/currentStatus';
import * as targetActions from 'modules/target';
import * as tagActions from 'modules/tag';
import * as examSummaryActions from 'modules/examSummary';

import { CtHeader, CtDashboard, CtExamLayout, CtTargetLayout, CtDeclareLayout, CtEduLayout, CtTemplateLayout } from 'containers';
import { NotFoundPage, MyPage } from 'pages';

// import io from 'socket.io-client';

let beforePath = '';
class MainPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      socketLoading: false,
      socketReserve: false
    };
  }

  componentDidMount() {
    // socket.io 처리
    // const socket = io('/socketio');
    // socket.on('action', msg => {
    //   const { ExamSummaryActions, serviceNo } = this.props;
    //   console.log('socket.io - msg' + msg.api + ' / exec : ' + msg.exec + ' / serviceNo' + msg.serviceNo);

    //   if (msg.serviceNo === serviceNo) {
    //     if (
    //       // 메일 확인
    //       msg.api === '/ReadEmail' ||
    //       // 첨부파일 다운로드 (링크 첨부)
    //       msg.exec === '/DownloadAttach' ||
    //       // 첨부파일 실행
    //       msg.exec === '/InfectionInfo' ||
    //       // 감염파일 생성
    //       msg.exec === '/LeakFile' ||
    //       // 첨부파일 실행
    //       msg.exec === '/Phishing/Connect' ||
    //       // 첨부파일 실행
    //       msg.exec === '/Phishing'
    //     ) {
    //       ExamSummaryActions.changeExamSummary({ name: 'needReload', value: true });
    //       // if (this.state.socketLoading) {
    //       //   this.setState({ socketLoading: false });
    //       //   ExamSummaryActions.changeExamSummary({ name: 'needReload', value: true });
    //       //   setTimeout(() => {
    //       //     this.setState({ socketLoading: true });
    //       //   }, 5000);
    //       // } else {
    //       //   this.setState({ socketReserve: true });
    //       // }
    //     }
    //   }
    // });

    window.addEventListener('click', this.catchEvent, false);
    window.addEventListener('keyup', this.catchEvent, false);

    // 모달 공통 validation 체크
    const { ReduxFormTouch, ReduxFormFocus } = this.props;
    window.markFieldValidate = (formStore, formName, fieldName) => {
      if (formStore && formStore && formStore.registeredFields) {
        if (!!fieldName) {
          if (formStore.registeredFields[fieldName].count > 0) {
            ReduxFormTouch(formName, fieldName);
            ReduxFormFocus(formName, fieldName);
          }
        } else {
          for (const field in formStore.registeredFields) {
            if (formStore.registeredFields.hasOwnProperty(field)) {
              if (formStore.registeredFields[field].count > 0) {
                ReduxFormTouch(formName, field);
                ReduxFormFocus(formName, field);
              }
            }
          }
        }
      }
    };

    const { CurrentStatusActions } = this.props;
    const { pathname } = this.props.location;
    CurrentStatusActions.changePath({
      path: pathname === '/main' || pathname === '/main/exam' ? '/main/exam/pi' : pathname
    });
    beforePath = pathname

    setTimeout(() => {
      const { ExamSummaryActions, TagActions, TargetActions } = this.props;
      if (pathname.indexOf('/main/exam') !== -1) {
        TagActions.getTag();
      } else if (pathname === '/main/target') {
        ExamSummaryActions.getExamSummary();
      }
    }, 500);
  }

  componentDidUpdate() {
    const { CurrentStatusActions } = this.props;
    const { pathname } = this.props.location;
    if (beforePath !== pathname && pathname !== '/main' && pathname !== '/main/exam') {
      CurrentStatusActions.changePath({
        path: pathname === '/main' || pathname === '/main/exam' ? '/main/exam/pi' : pathname, 
        beforePath: beforePath 
      });
      beforePath =  pathname;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.catchEvent, false);
    window.removeEventListener('keyup', this.catchEvent, false);

    // const socket = io('/socketio');
    // socket.close();
  }

  catchEvent = e => {
    if (
      // esc키
      (e && e.type === 'keyup' && e.key && e.key.toLowerCase() === 'escape') ||
      // 수정중인 영역이 아닐 경우에 close 처리
      (!!e.path &&
        common.findIndex(e.path, target => target.className === 'editMode-area') === -1 &&
        common.findIndex(e.path, target => target.className === 'editMode-area no-enter') === -1)
      // e.path.findIndex(target => target.className === 'editMode-area') === -1 &&
      // e.path.findIndex(target => target.className === 'editMode-area no-enter') === -1)
    ) {
      const { CurrentStatusActions } = this.props;

      CurrentStatusActions.clear();
      // 엔터 입력시 저장
    } else if (
      e.type === 'keyup' &&
      e.key.toLowerCase() === 'enter' &&
      common.findIndex(e.path, target => target.className === 'editMode-area no-enter') === -1
      // e.path.findIndex(target => target.className === 'editMode-area no-enter') === -1
    ) {
      // 태그 등록 드랍다운 제외, 메모의 경우도 제외
      if (e.target.name !== 'targetTag' && e.target.name !== 'targetDetail') {
        const { CurrentStatusActions } = this.props;

        CurrentStatusActions.triggerEnter({ bool: true });
      }
    }

    // 세션시간 연장
    sessionStorage.setItem('accessTime', common.nowEpoch());

    if (commonVar.isGs === 1) {
      // 다중 로그인 방지
      if (
        !localStorage.getItem('loginUser') ||
        sessionStorage.getItem('curUser') !== localStorage.getItem('loginUser')
      ) {
        const { UserActions, LoginActions } = this.props;

        // 로그아웃 처리
        UserActions.initialStore();
        // 로그인 초기화
        LoginActions.setInitial();
      }
    } else if (!localStorage.getItem('loginUser')) {
      localStorage.removeItem('loginAdmin');
      localStorage.removeItem('loginUser');
      sessionStorage.removeItem('curUser');

      const { UserActions, LoginActions } = this.props;

      // 로그아웃 처리
      UserActions.initialStore();
      // 로그인 초기화
      LoginActions.setInitial();
    }
  };

  render() {
    return (
      <div className="main-wrapper">
        <div className="main-header">
          <Route path="/" component={CtHeader} />
        </div>
        <div className="main-content">
          <div className="main-content-inner">
            <Switch>
              <Route exact path="/main/dashboard" component={CtDashboard} />
              {/* <Route exact path="/main" render={() => <Redirect to="/main/exam/pi" />} /> */}
              <Route exact path="/main" render={() => <Redirect to="/main/dashboard" />} />
              <Route exact path="/main/exam" render={() => <Redirect to="/main/exam/pi" />} />
              {/* <Route exact path="/main/target" render={() => <Redirect to="/main/target" />} /> */}
              <Route path="/main/exam/pi" component={CtExamLayout} />
              <Route exact path="/main/exam/tag" component={CtExamLayout} />
              <Route exact path="/main/exam/infectionpc" component={CtExamLayout} />
              <Route exact path="/main/exam/leakfile" component={CtExamLayout} />
              <Route exact path="/main/target" component={CtTargetLayout} />
              <Route exact path="/main/edu" component={CtEduLayout} />
              <Route exact path="/main/declaration" render={() => <Redirect to="/main/declaration/exam" />} />
              <Route exact path="/main/declaration/exam" component={CtDeclareLayout} />
              <Route exact path="/main/declaration/mail" component={CtDeclareLayout} />
              <Route path="/main/mypage" component={MyPage} />
              <Route exact path="/main/allTemplate" render={() => <Redirect to="/main/allTemplate/examtemplate" />} />
              <Route exact path="/main/allTemplate/examtemplate" component={CtTemplateLayout} />
              <Route exact path="/main/allTemplate/examtemplate/phishing" component={CtTemplateLayout} />
              <Route exact path="/main/allTemplate/edutemplate" component={CtTemplateLayout} />
              <Route exact path="/main/allTemplate/edutemplate/quiz" component={CtTemplateLayout} />

              <Route component={NotFoundPage} />
            </Switch>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    serviceNo: state.user.get('user').serviceNo
  };
};

const mapDispatchToProps = dispatch => ({
  UserActions: bindActionCreators(userActions, dispatch),
  LoginActions: bindActionCreators(loginActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch),
  TargetActions: bindActionCreators(targetActions, dispatch),
  TagActions: bindActionCreators(tagActions, dispatch),
  ExamSummaryActions: bindActionCreators(examSummaryActions, dispatch),
  ReduxFormTouch: bindActionCreators(touch, dispatch),
  ReduxFormFocus: bindActionCreators(focus, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(MainPage);



// WEBPACK FOOTER //
// ./src/script/pages/MainPage.js